import { Link } from "react-router-dom";
import { Avatar, TrustBadge, Stars, VerifiedTick, rupee } from "./Bits";
import { MapPin } from "lucide-react";

export default function CarerCard({ carer, onBook, compact = false }) {
  return (
    <div className="card-bmc p-5 flex flex-col" data-testid={`carer-card-${carer.id}`}>
      <div className="flex items-start gap-4">
        <Avatar initials={carer.avatar_initials} gradient={carer.gradient} size={56} />
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-1.5">
            <Link to={`/carer/${carer.id}`} className="font-display font-bold text-ink hover:text-coral truncate">{carer.name}</Link>
            {carer.verification_status === "Verified" && <VerifiedTick />}
          </div>
          <p className="text-coral text-sm font-semibold">{carer.role}</p>
          <p className="text-xs text-ink-soft flex items-center gap-1 mt-1">
            <MapPin size={12} /> {carer.area || carer.city} · {carer.exp_years} yrs
          </p>
          <p className="text-xs text-ink-faint mt-0.5 truncate">{(carer.languages || []).join(" · ")}</p>
        </div>
      </div>

      <div className="flex flex-wrap gap-1.5 mt-3">
        {(carer.badges || []).map((b) => <TrustBadge key={b} type={b} />)}
      </div>

      <div className="flex items-center justify-between mt-4 pt-4 border-t border-line-2">
        <div>
          <span className="font-display font-bold text-lg text-ink">{rupee(carer.rate)}</span>
          <span className="text-xs text-ink-soft">{carer.unit}</span>
        </div>
        <Stars rating={carer.rating} />
      </div>

      {!compact && (
        <div className="grid grid-cols-2 gap-2 mt-4">
          <Link to={`/carer/${carer.id}`} className="btn-pill justify-center border border-line text-ink px-4 py-2 text-sm hover:border-coral" data-testid={`view-${carer.id}`}>
            View Profile
          </Link>
          <button onClick={() => onBook?.(carer)} className="btn-pill justify-center bg-coral text-white px-4 py-2 text-sm hover:bg-coral-deep" data-testid={`book-${carer.id}`}>
            Book Now
          </button>
        </div>
      )}
    </div>
  );
}
